module.exports = __webpack_public_path__ + "static/tracking-bcd8ec8e634c8035e354b923c57517c5.png";